/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "@/utils/helpers/pagination";

export default {
  SET_LIST_WITH_PAGINATION(state, data) {
    state.list = data.items || [];
    state.pagination = data.pagination || {};
  },
  SET_LIST(state, data) {
    state.list = data || [];
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
  SET_DETAIL(state, student) {
    state.selecting = student;
  },
  ADD_STUDENT(state, student) {
    state.list.push(student);
  },
  UPDATE_STUDENT(state, student) {
    const userIndex = state.list.findIndex((u) => u.id === student.id);
    if (userIndex >= 0) Object.assign(state.students[userIndex], student);
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const userIndex = state.list.findIndex((u) => u.id === item);
        state.list.splice(userIndex, 1);
      });
    } else {
      const userIndex = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(userIndex, 1);
    }

    state.pagination = setPagination(state.pagination, itemId);
  },
};
